import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Menu from './components/Menu';
import AnimatedSlogan from './components/AnimatedSlogan';
import About from './components/About';
import VideoSection from './components/VideoSection';
import Contact from './components/Contact';
import Franchise from './components/Franchise';
import Merch from './components/Merch';
import Footer from './components/Footer';
import Info from './components/Info';
import Loader from './components/Loader';
import PerformanceOptimizer from './components/PerformanceOptimizer';
import './App.css';
import Reviews from './components/Reviews';
import ReservationCTA from './components/ReservationCTA';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
    document.body.style.overflow = 'auto';
  };

  if (isLoading) {
    document.body.style.overflow = 'hidden';
  }

  return (
    <>
      {/* ⚡ Global Performance Optimizer */}
      <PerformanceOptimizer />
      
      {isLoading && <Loader onLoadingComplete={handleLoadingComplete} />}
      
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                                  <div id="hero">
                    <Hero />
                  </div>
                  {/* Menu retiré de la page d'accueil */}
                  <div id="slogan">
                    <AnimatedSlogan />
                  </div>
                  <div id="about">
                    <About />
                  </div>
                  <div id="video">
                    <VideoSection />
                  </div>
                  <ReservationCTA />
                  <div id="reviews">
                    <Reviews />
                  </div>

              </>
            } />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/info" element={<Info />} />
            <Route path="/merch" element={<Merch />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App; 